import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  tab: {
    display: "flex",
    position: "relative",
    padding: "8px 12px",
    height: "40px",
    fontSize: "14px",
    fontWeight: 500,
    backgroundColor: "#fafaff",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    border: "1px solid #f0f0fa",
    marginRight: "4px",
    color: "#7d8696",
    cursor: "pointer",
  },
  selected: {
    backgroundColor: "#ffffff",
    color: "#1a7fda",
    border: "none",
  },
  label: {
    fontWeight: 500,
    fontSize: "14px",
    marginLeft: "4px",
    lineHeight: "24px",
    maxWidth: "60px",
    height: "24px",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
  },
  removeMargin: {
    margin: 0,
  },
  iconOnly: {
    maxWidth: "50px !important" as "50px",
  },
}));

export default useStyles;
